module.exports = __webpack_public_path__ + "img/img_037@2x.ac72aaa6.png";